import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'


const _hoisted_1 = { class: "ask-reset-password" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_4 = {
  slot: "form",
  class: "ask-password-form"
}
const _hoisted_5 = { class: "info-text" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  slot: "links",
  class: "link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_locale_select = _resolveComponent("base-locale-select")!

  return (_openBlock(), _createElementBlock("dig-ui-login-card", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("dig-ui-title", _hoisted_3, _toDisplayString(_ctx.$t('askResetPassword')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('askResetPasswordMessage')), 1),
      _createElementVNode("dig-input-text", {
        value: _ctx.username,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.username = $event.target.value)),
        id: "username",
        name: "username",
        required: ""
      }, _toDisplayString(_ctx.$t('User.usernameOrEmail')), 41, _hoisted_6),
      _createElementVNode("div", null, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("dig-ui-standard-button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.askResetPassword(_ctx.username)))
            }, _toDisplayString(_ctx.$t('validate')), 1))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("dig-ui-loader", _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_base_locale_select)
      ])
    ])
  ]))
}